import VersionMessagePopup from './VersionMessagePopup'

export default VersionMessagePopup